import 'babel-polyfill';
import './ie8.js';
/**
 * Import the application module.
 */
import app from './app.module.js';
import pageFooter from './login/footer/bcb.pageFooter.js';
import pageHeader from './login/header/bcb.pageHeader.js';
import forgotten from './login/forgotten/wai.forgotten.js';
import match from './login/establishmemword/match.js';
import languageSelector from './login/languageselector/languageSelector.js';
import account  from './login/account/account.wai.js';
import Fingerprint2 from 'fingerprintjs2';

angular.module(app)
    .directive('pageFooter', pageFooter)
    .directive('pageHeader', pageHeader)
    .directive('forgotten', forgotten)
    .directive('account', account)
    .directive('match', match)
    .directive('languageSelector', languageSelector)
    .value('whitelabel', 'bcb')
    .value('deviceprintFnBmo', Fingerprint2)
    .value('deviceprintFn', Fingerprint2);
    
/**
 * Import all application styles here.
 */
import './app.bcb.less';



// WEBPACK FOOTER //
// ./src/app.bcb.js